import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Oies = React.lazy(() => import('./index'));
const OieTable = React.lazy(() => import('./oieTable'));
const Oie = React.lazy(() => import('./oie'));
const OieDetail = React.lazy(() => import('./oieDetail'));
const AddNewOie = React.lazy(() => import('./addNewOie'));
const EditOie = React.lazy(() => import('./editOie'));

export const useOieRoutes = () => {

    return (
        <React.Fragment>
            <Route path="oie" element={<Suspense fallback={<div>منتظر باشید...</div>}><Oies /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><OieTable /></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewOie /></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Oie /></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><OieDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditOie /></Suspense> } />
                </Route>
            </Route>
        </React.Fragment>
    )
}